// Team Admin i18n — finance (payouts, earnings).
const en = {
  "admin.pay.title": "Payouts",
  "admin.pay.subtitle": "Review, approve and settle artist withdrawal requests",
  "admin.pay.refresh": "Refresh",
  "admin.pay.exportCsv": "Export CSV",
  "admin.pay.exportSelected": "Export {n} selected",
  "admin.pay.exported": "{n} payouts exported",
  "admin.pay.exportFailed": "Export failed",
  "admin.pay.nothingToExport": "Nothing to export",
  "admin.pay.loadFailed": "Could not load payouts",
  "admin.pay.retry": "Retry",
  "admin.pay.filter": "Status filter",
  "admin.pay.all": "All",
  "admin.pay.searchPlaceholder": "Search name, email, IBAN, ID…",
  "admin.pay.sum.pending": "Pending amount",
  "admin.pay.sum.requested": "New requests",
  "admin.pay.sum.awaiting": "Approved, awaiting payment",
  "admin.pay.sum.paid": "Paid out (all time)",
  "admin.pay.status.requested": "Requested",
  "admin.pay.status.approved": "Approved",
  "admin.pay.status.rejected": "Rejected",
  "admin.pay.status.paid": "Paid",
  "admin.pay.method.bank": "Bank transfer",
  "admin.pay.method.other": "Other",
  "admin.pay.col.user": "User",
  "admin.pay.col.amount": "Amount",
  "admin.pay.col.method": "Method",
  "admin.pay.col.status": "Status",
  "admin.pay.col.date": "Requested",
  "admin.pay.col.actions": "Actions",
  "admin.pay.selectAll": "Select all on this page",
  "admin.pay.select": "Select",
  "admin.pay.selected": "{n} selected",
  "admin.pay.clearSelection": "Clear",
  "admin.pay.bulkApprove": "Approve ({n})",
  "admin.pay.bulkPaid": "Mark paid ({n})",
  "admin.pay.bulkReject": "Reject ({n})",
  "admin.pay.bulkDone": "{n} payouts updated",
  "admin.pay.bulkPartial": "{ok} updated, {failed} skipped",
  "admin.pay.details": "Details",
  "admin.pay.approve": "Approve",
  "admin.pay.reject": "Reject",
  "admin.pay.markPaid": "Mark paid",
  "admin.pay.cancel": "Cancel",
  "admin.pay.close": "Close",
  "admin.pay.copy": "Copy",
  "admin.pay.copied": "Copied",
  "admin.pay.copyFailed": "Copy failed",
  "admin.pay.reasonRequired": "A rejection reason is required",
  "admin.pay.actionFailed": "Action failed",
  "admin.pay.done.approve": "Payout approved",
  "admin.pay.done.reject": "Payout rejected",
  "admin.pay.done.paid": "Payout marked as paid",
  "admin.pay.emptyTitle": "No payout requests",
  "admin.pay.emptyDesc": "There are no payout requests for this filter.",
  "admin.pay.emptySearch": "No payouts match your search.",
  "admin.pay.pageOf": "Page {page} of {pages} · {total} payouts",
  "admin.pay.prev": "Previous page",
  "admin.pay.next": "Next page",
  "admin.pay.dialog.approve": "Approve payout",
  "admin.pay.dialog.reject": "Reject payout",
  "admin.pay.dialog.paid": "Mark as paid",
  "admin.pay.dialog.bulkDesc": "This action will be applied to {n} payouts.",
  "admin.pay.dialog.count": "Payouts",
  "admin.pay.dialog.reasonRequired": "Rejection reason (required)",
  "admin.pay.dialog.noteOptional": "Note (optional)",
  "admin.pay.dialog.reasonPlaceholder": "Explain why the request is rejected…",
  "admin.pay.dialog.notePlaceholder": "Optional internal note…",
  "admin.pay.dialog.paidHint": "Only confirm after the transfer has actually been sent. The artist will be notified.",
  "admin.pay.confirm.approve": "Approve",
  "admin.pay.confirm.reject": "Reject",
  "admin.pay.confirm.paid": "Mark paid",
  "admin.pay.det.title": "Payout request details",
  "admin.pay.det.requester": "Requested by",
  "admin.pay.det.amount": "Requested amount",
  "admin.pay.det.rejectionReason": "Rejection reason",
  "admin.pay.det.snapshotTitle": "Payment snapshot (at request time)",
  "admin.pay.det.snapshotDesc": "These details were captured when the request was created and cannot be changed.",
  "admin.pay.det.paypalEmail": "PayPal email",
  "admin.pay.det.accountNumber": "Account number",
  "admin.pay.det.accountHolder": "Account holder",
  "admin.pay.det.bank": "Bank",
  "admin.pay.det.country": "Country",
  "admin.pay.det.currency": "Currency",
  "admin.pay.det.profileTitle": "Profile snapshot (at request time)",
  "admin.pay.det.individual": "Individual",
  "admin.pay.det.business": "Business",
  "admin.pay.det.legalName": "Legal name",
  "admin.pay.det.displayName": "Display name",
  "admin.pay.det.phone": "Phone",
  "admin.pay.det.email": "Email",
  "admin.pay.det.address": "Address",
  "admin.pay.det.cityCountry": "City / Country",
  "admin.pay.det.company": "Company",
  "admin.pay.det.companyReg": "Company registration no.",
  "admin.pay.det.taxStatus": "Tax status",
  "admin.pay.det.taxCountry": "Tax country",
  "admin.pay.det.taxId": "Tax ID (masked)",
  "admin.pay.det.requestedAt": "Requested at",
  "admin.earn.title": "Earnings",
  "admin.earn.subtitle": "Revenue records entered for releases, with commission and payee splits",
  "admin.earn.loadFailed": "Could not load earnings",
  "admin.earn.kpi.gross": "Gross",
  "admin.earn.kpi.commission": "Platform commission",
  "admin.earn.kpi.net": "Net to artists",
  "admin.earn.kpi.records": "Records",
  "admin.earn.chartTitle": "Last 12 months",
  "admin.earn.mixedCurrency": "Multiple currencies ({list}) — chart shows raw sums without conversion.",
  "admin.earn.noChart": "No revenue recorded in the last 12 months.",
  "admin.earn.filter": "Status filter",
  "admin.earn.status.all": "All",
  "admin.earn.status.calculated": "Calculated",
  "admin.earn.status.paid": "Paid",
  "admin.earn.col.track": "Track",
  "admin.earn.col.payees": "Payees",
  "admin.earn.col.period": "Period",
  "admin.earn.col.status": "Status",
  "admin.earn.col.created": "Entered",
  "admin.earn.viewRelease": "View release",
  "admin.earn.morePayees": "+{n} more",
  "admin.earn.emptyTitle": "No revenue records",
  "admin.earn.emptyDesc": "No revenue has been entered for this filter yet.",
  "admin.earn.pageOf": "Page {page} of {pages} · {total} records",
};
const tr = {
  "admin.pay.title": "Ödeme Yönetimi",
  "admin.pay.subtitle": "Sanatçı çekim taleplerini inceleyin, onaylayın ve ödeyin",
  "admin.pay.refresh": "Yenile",
  "admin.pay.exportCsv": "CSV dışa aktar",
  "admin.pay.exportSelected": "Seçili {n} kaydı aktar",
  "admin.pay.exported": "{n} ödeme dışa aktarıldı",
  "admin.pay.exportFailed": "Dışa aktarma başarısız",
  "admin.pay.nothingToExport": "Dışa aktarılacak kayıt yok",
  "admin.pay.loadFailed": "Ödemeler yüklenemedi",
  "admin.pay.retry": "Tekrar dene",
  "admin.pay.filter": "Durum filtresi",
  "admin.pay.all": "Tümü",
  "admin.pay.searchPlaceholder": "Ad, e-posta, IBAN, ID ara…",
  "admin.pay.sum.pending": "Bekleyen tutar",
  "admin.pay.sum.requested": "Yeni talepler",
  "admin.pay.sum.awaiting": "Onaylı, ödeme bekliyor",
  "admin.pay.sum.paid": "Ödenen (toplam)",
  "admin.pay.status.requested": "Talep Edildi",
  "admin.pay.status.approved": "Onaylandı",
  "admin.pay.status.rejected": "Reddedildi",
  "admin.pay.status.paid": "Ödendi",
  "admin.pay.method.bank": "Banka transferi",
  "admin.pay.method.other": "Diğer",
  "admin.pay.col.user": "Kullanıcı",
  "admin.pay.col.amount": "Tutar",
  "admin.pay.col.method": "Yöntem",
  "admin.pay.col.status": "Durum",
  "admin.pay.col.date": "Talep tarihi",
  "admin.pay.col.actions": "İşlemler",
  "admin.pay.selectAll": "Bu sayfadakilerin tümünü seç",
  "admin.pay.select": "Seç",
  "admin.pay.selected": "{n} seçili",
  "admin.pay.clearSelection": "Temizle",
  "admin.pay.bulkApprove": "Onayla ({n})",
  "admin.pay.bulkPaid": "Ödendi işaretle ({n})",
  "admin.pay.bulkReject": "Reddet ({n})",
  "admin.pay.bulkDone": "{n} ödeme güncellendi",
  "admin.pay.bulkPartial": "{ok} güncellendi, {failed} atlandı",
  "admin.pay.details": "Detay",
  "admin.pay.approve": "Onayla",
  "admin.pay.reject": "Reddet",
  "admin.pay.markPaid": "Ödendi",
  "admin.pay.cancel": "İptal",
  "admin.pay.close": "Kapat",
  "admin.pay.copy": "Kopyala",
  "admin.pay.copied": "Kopyalandı",
  "admin.pay.copyFailed": "Kopyalama başarısız",
  "admin.pay.reasonRequired": "Reddetme sebebi zorunludur",
  "admin.pay.actionFailed": "İşlem başarısız",
  "admin.pay.done.approve": "Ödeme onaylandı",
  "admin.pay.done.reject": "Ödeme reddedildi",
  "admin.pay.done.paid": "Ödeme yapıldı olarak işaretlendi",
  "admin.pay.emptyTitle": "Ödeme talebi bulunamadı",
  "admin.pay.emptyDesc": "Seçili filtre için ödeme talebi bulunmuyor.",
  "admin.pay.emptySearch": "Aramanızla eşleşen ödeme yok.",
  "admin.pay.pageOf": "Sayfa {page}/{pages} · {total} ödeme",
  "admin.pay.prev": "Önceki sayfa",
  "admin.pay.next": "Sonraki sayfa",
  "admin.pay.dialog.approve": "Ödemeyi onayla",
  "admin.pay.dialog.reject": "Ödemeyi reddet",
  "admin.pay.dialog.paid": "Ödendi olarak işaretle",
  "admin.pay.dialog.bulkDesc": "Bu işlem {n} ödemeye uygulanacak.",
  "admin.pay.dialog.count": "Ödeme sayısı",
  "admin.pay.dialog.reasonRequired": "Reddetme sebebi (zorunlu)",
  "admin.pay.dialog.noteOptional": "Not (opsiyonel)",
  "admin.pay.dialog.reasonPlaceholder": "Talebin neden reddedildiğini açıklayın…",
  "admin.pay.dialog.notePlaceholder": "Opsiyonel dahili not…",
  "admin.pay.dialog.paidHint": "Yalnızca transfer gerçekten gönderildikten sonra onaylayın. Sanatçıya bildirim gider.",
  "admin.pay.confirm.approve": "Onayla",
  "admin.pay.confirm.reject": "Reddet",
  "admin.pay.confirm.paid": "Ödendi işaretle",
  "admin.pay.det.title": "Ödeme talebi detayları",
  "admin.pay.det.requester": "Talep sahibi",
  "admin.pay.det.amount": "Talep tutarı",
  "admin.pay.det.rejectionReason": "Reddetme sebebi",
  "admin.pay.det.snapshotTitle": "Ödeme snapshot'ı (talep anındaki bilgiler)",
  "admin.pay.det.snapshotDesc": "Bu bilgiler talep oluşturulduğu andaki değerlerdir ve değiştirilemez.",
  "admin.pay.det.paypalEmail": "PayPal e-posta",
  "admin.pay.det.accountNumber": "Hesap numarası",
  "admin.pay.det.accountHolder": "Hesap sahibi",
  "admin.pay.det.bank": "Banka",
  "admin.pay.det.country": "Ülke",
  "admin.pay.det.currency": "Para birimi",
  "admin.pay.det.profileTitle": "Profil snapshot'ı (talep anındaki bilgiler)",
  "admin.pay.det.individual": "Bireysel",
  "admin.pay.det.business": "Kurumsal",
  "admin.pay.det.legalName": "Yasal ad",
  "admin.pay.det.displayName": "Görünen ad",
  "admin.pay.det.phone": "Telefon",
  "admin.pay.det.email": "E-posta",
  "admin.pay.det.address": "Adres",
  "admin.pay.det.cityCountry": "Şehir / Ülke",
  "admin.pay.det.company": "Şirket adı",
  "admin.pay.det.companyReg": "Şirket sicil no",
  "admin.pay.det.taxStatus": "Vergi durumu",
  "admin.pay.det.taxCountry": "Vergi ülkesi",
  "admin.pay.det.taxId": "Vergi kimlik no (maskeli)",
  "admin.pay.det.requestedAt": "Talep tarihi",
  "admin.earn.title": "Kazanç Yönetimi",
  "admin.earn.subtitle": "Yayınlar için girilen gelir kayıtları, komisyon ve hak sahibi paylarıyla",
  "admin.earn.loadFailed": "Kazançlar yüklenemedi",
  "admin.earn.kpi.gross": "Brüt",
  "admin.earn.kpi.commission": "Platform komisyonu",
  "admin.earn.kpi.net": "Sanatçılara net",
  "admin.earn.kpi.records": "Kayıt",
  "admin.earn.chartTitle": "Son 12 ay",
  "admin.earn.mixedCurrency": "Birden fazla para birimi ({list}) — grafik dönüşümsüz ham toplamları gösterir.",
  "admin.earn.noChart": "Son 12 ayda gelir kaydı yok.",
  "admin.earn.filter": "Durum filtresi",
  "admin.earn.status.all": "Tümü",
  "admin.earn.status.calculated": "Hesaplandı",
  "admin.earn.status.paid": "Ödendi",
  "admin.earn.col.track": "Parça",
  "admin.earn.col.payees": "Hak sahipleri",
  "admin.earn.col.period": "Dönem",
  "admin.earn.col.status": "Durum",
  "admin.earn.col.created": "Giriş tarihi",
  "admin.earn.viewRelease": "Yayını görüntüle",
  "admin.earn.morePayees": "+{n} kişi daha",
  "admin.earn.emptyTitle": "Gelir kaydı yok",
  "admin.earn.emptyDesc": "Bu filtre için henüz gelir girilmemiş.",
  "admin.earn.pageOf": "Sayfa {page}/{pages} · {total} kayıt",
};
const es = {
  "admin.pay.title": "Pagos",
  "admin.pay.subtitle": "Revisa, aprueba y liquida las solicitudes de retiro de los artistas",
  "admin.pay.refresh": "Actualizar",
  "admin.pay.exportCsv": "Exportar CSV",
  "admin.pay.exportSelected": "Exportar {n} seleccionados",
  "admin.pay.exported": "{n} pagos exportados",
  "admin.pay.exportFailed": "Error al exportar",
  "admin.pay.nothingToExport": "No hay nada que exportar",
  "admin.pay.loadFailed": "No se pudieron cargar los pagos",
  "admin.pay.retry": "Reintentar",
  "admin.pay.filter": "Filtro de estado",
  "admin.pay.all": "Todos",
  "admin.pay.searchPlaceholder": "Buscar nombre, email, IBAN, ID…",
  "admin.pay.sum.pending": "Importe pendiente",
  "admin.pay.sum.requested": "Solicitudes nuevas",
  "admin.pay.sum.awaiting": "Aprobados, pendientes de pago",
  "admin.pay.sum.paid": "Pagado (total)",
  "admin.pay.status.requested": "Solicitado",
  "admin.pay.status.approved": "Aprobado",
  "admin.pay.status.rejected": "Rechazado",
  "admin.pay.status.paid": "Pagado",
  "admin.pay.method.bank": "Transferencia bancaria",
  "admin.pay.method.other": "Otro",
  "admin.pay.col.user": "Usuario",
  "admin.pay.col.amount": "Importe",
  "admin.pay.col.method": "Método",
  "admin.pay.col.status": "Estado",
  "admin.pay.col.date": "Solicitado",
  "admin.pay.col.actions": "Acciones",
  "admin.pay.selectAll": "Seleccionar todo en esta página",
  "admin.pay.select": "Seleccionar",
  "admin.pay.selected": "{n} seleccionados",
  "admin.pay.clearSelection": "Limpiar",
  "admin.pay.bulkApprove": "Aprobar ({n})",
  "admin.pay.bulkPaid": "Marcar pagados ({n})",
  "admin.pay.bulkReject": "Rechazar ({n})",
  "admin.pay.bulkDone": "{n} pagos actualizados",
  "admin.pay.bulkPartial": "{ok} actualizados, {failed} omitidos",
  "admin.pay.details": "Detalles",
  "admin.pay.approve": "Aprobar",
  "admin.pay.reject": "Rechazar",
  "admin.pay.markPaid": "Marcar pagado",
  "admin.pay.cancel": "Cancelar",
  "admin.pay.close": "Cerrar",
  "admin.pay.copy": "Copiar",
  "admin.pay.copied": "Copiado",
  "admin.pay.copyFailed": "No se pudo copiar",
  "admin.pay.reasonRequired": "El motivo del rechazo es obligatorio",
  "admin.pay.actionFailed": "La acción falló",
  "admin.pay.done.approve": "Pago aprobado",
  "admin.pay.done.reject": "Pago rechazado",
  "admin.pay.done.paid": "Pago marcado como pagado",
  "admin.pay.emptyTitle": "No hay solicitudes de pago",
  "admin.pay.emptyDesc": "No hay solicitudes de pago para este filtro.",
  "admin.pay.emptySearch": "Ningún pago coincide con tu búsqueda.",
  "admin.pay.pageOf": "Página {page} de {pages} · {total} pagos",
  "admin.pay.prev": "Página anterior",
  "admin.pay.next": "Página siguiente",
  "admin.pay.dialog.approve": "Aprobar pago",
  "admin.pay.dialog.reject": "Rechazar pago",
  "admin.pay.dialog.paid": "Marcar como pagado",
  "admin.pay.dialog.bulkDesc": "Esta acción se aplicará a {n} pagos.",
  "admin.pay.dialog.count": "Pagos",
  "admin.pay.dialog.reasonRequired": "Motivo del rechazo (obligatorio)",
  "admin.pay.dialog.noteOptional": "Nota (opcional)",
  "admin.pay.dialog.reasonPlaceholder": "Explica por qué se rechaza la solicitud…",
  "admin.pay.dialog.notePlaceholder": "Nota interna opcional…",
  "admin.pay.dialog.paidHint": "Confirma solo después de haber enviado la transferencia. Se notificará al artista.",
  "admin.pay.confirm.approve": "Aprobar",
  "admin.pay.confirm.reject": "Rechazar",
  "admin.pay.confirm.paid": "Marcar pagado",
  "admin.pay.det.title": "Detalles de la solicitud de pago",
  "admin.pay.det.requester": "Solicitado por",
  "admin.pay.det.amount": "Importe solicitado",
  "admin.pay.det.rejectionReason": "Motivo del rechazo",
  "admin.pay.det.snapshotTitle": "Datos de pago (al momento de la solicitud)",
  "admin.pay.det.snapshotDesc": "Estos datos se guardaron al crear la solicitud y no se pueden modificar.",
  "admin.pay.det.paypalEmail": "Email de PayPal",
  "admin.pay.det.accountNumber": "Número de cuenta",
  "admin.pay.det.accountHolder": "Titular de la cuenta",
  "admin.pay.det.bank": "Banco",
  "admin.pay.det.country": "País",
  "admin.pay.det.currency": "Moneda",
  "admin.pay.det.profileTitle": "Datos del perfil (al momento de la solicitud)",
  "admin.pay.det.individual": "Particular",
  "admin.pay.det.business": "Empresa",
  "admin.pay.det.legalName": "Nombre legal",
  "admin.pay.det.displayName": "Nombre visible",
  "admin.pay.det.phone": "Teléfono",
  "admin.pay.det.email": "Email",
  "admin.pay.det.address": "Dirección",
  "admin.pay.det.cityCountry": "Ciudad / País",
  "admin.pay.det.company": "Empresa",
  "admin.pay.det.companyReg": "N.º de registro mercantil",
  "admin.pay.det.taxStatus": "Situación fiscal",
  "admin.pay.det.taxCountry": "País fiscal",
  "admin.pay.det.taxId": "ID fiscal (enmascarado)",
  "admin.pay.det.requestedAt": "Fecha de solicitud",
  "admin.earn.title": "Ganancias",
  "admin.earn.subtitle": "Registros de ingresos de los lanzamientos, con comisión y reparto entre beneficiarios",
  "admin.earn.loadFailed": "No se pudieron cargar las ganancias",
  "admin.earn.kpi.gross": "Bruto",
  "admin.earn.kpi.commission": "Comisión de la plataforma",
  "admin.earn.kpi.net": "Neto para artistas",
  "admin.earn.kpi.records": "Registros",
  "admin.earn.chartTitle": "Últimos 12 meses",
  "admin.earn.mixedCurrency": "Varias monedas ({list}): el gráfico muestra sumas sin conversión.",
  "admin.earn.noChart": "No hay ingresos registrados en los últimos 12 meses.",
  "admin.earn.filter": "Filtro de estado",
  "admin.earn.status.all": "Todos",
  "admin.earn.status.calculated": "Calculado",
  "admin.earn.status.paid": "Pagado",
  "admin.earn.col.track": "Pista",
  "admin.earn.col.payees": "Beneficiarios",
  "admin.earn.col.period": "Periodo",
  "admin.earn.col.status": "Estado",
  "admin.earn.col.created": "Registrado",
  "admin.earn.viewRelease": "Ver lanzamiento",
  "admin.earn.morePayees": "+{n} más",
  "admin.earn.emptyTitle": "No hay registros de ingresos",
  "admin.earn.emptyDesc": "Aún no se han registrado ingresos para este filtro.",
  "admin.earn.pageOf": "Página {page} de {pages} · {total} registros",
};
export default { en, tr, es };
